// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Model imports
import { BaseWorkflowSearchParameterDto } from '../_models/workflow-reimbursement-request/base-workflow-search-parameter-dto';
import { BaseWorkflowSearchResultDto } from '../_models/workflow-reimbursement-request/base-workflow-search-result-dto';
import { WFReimbursementRequestEditorParameterDto } from '../_models/workflow-reimbursement-request/wf-reimbursement-request-editor-parameter-dto';
import { WFReimbursementRequestEditorResultDto } from '../_models/workflow-reimbursement-request/wf-reimbursement-request-editor-result-dto';
import { WFReimbursementRequestRawDto } from '../_models/workflow-reimbursement-request/wf-reimbursement-request-raw-dto';
import { WFReimbursementAttachReceiptParametersDto } from '../_models/workflow-reimbursement-request/wf-reimbursement-attach-receipt-parameters-dto';
import { WFReimbursementRequestLineItemsResultDto } from '../_models/workflow-reimbursement-request/wf-reimbursement-request-line-items-result-dto';
import { WFToggleReimbursableParametersDto } from '../_models/workflow-reimbursement-request/wf-toggle-reimbursable-parameters-dto';

// constant imports
import { URLConstants } from '../../_constants/url-constants';

@Injectable({
    providedIn: 'root'
})
export class WorkflowReimbursementRequestService {
    constructor(private readonly httpClient: HttpClient) {}

    getWorflowReimbursements(baseParam: BaseWorkflowSearchParameterDto): Observable<BaseWorkflowSearchResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement${baseParam.getQueryString()}`;

        return this.httpClient
            .get(url)
            .pipe(map((response: any[]) => plainToClass(BaseWorkflowSearchResultDto, response)));
    }

    getWorkflowReimbursementEditor(
        baseParam: WFReimbursementRequestEditorParameterDto
    ): Observable<WFReimbursementRequestEditorResultDto> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/editor${baseParam.getQueryString()}`;

        return this.httpClient
            .get(url)
            .pipe(map((response: any) => plainToClass(WFReimbursementRequestEditorResultDto, response)));
    }

    getWorkflowReimbursementEditorLineItems(
        baseParam: WFReimbursementRequestEditorParameterDto
    ): Observable<WFReimbursementRequestLineItemsResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/lineItems${baseParam.getQueryString()}`;

        return this.httpClient
            .get(url)
            .pipe(map((response: any[]) => plainToClass(WFReimbursementRequestLineItemsResultDto, response)));
    }

    saveWorkflowReimbursementEditor(baseParam: WFReimbursementRequestRawDto): Observable<any> {
        return this.httpClient
            .post(`${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement`, classToPlain(baseParam))
            .pipe(map((responseData: any) => responseData));
    }

    attachLineItemReceipt(baseParam: WFReimbursementAttachReceiptParametersDto): Observable<any> {
        return this.httpClient
            .post(`${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/lineitem/receipt`, classToPlain(baseParam))
            .pipe(map((responseData: any) => responseData));
    }

    toggleLineItemReimbursement(baseParam: WFToggleReimbursableParametersDto): Observable<any> {
        return this.httpClient
            .post(`${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/lineitem/toggle`, classToPlain(baseParam))
            .pipe(map((responseData: any) => responseData));
    }
}
